import CTFCompetition from './CTFCompetition';
import ExploreResourcesSection from './ExploreResourcesSection';
import Footer from './Footer';
import HeroSection from './HeroSection';
import Layout from './Layout';
import SupportSection from './SupportSection';
import TestmonialSection from './TestmonialSection';
import TrustedOrganizations from './TrustedOrganizations';

export default function LandingPage() {
  return (
    <div>
      <Layout showFooter={false}>
        <div className="space-y-32">
          <HeroSection
            title="Cybersecurity Simulations Copilot"
            blueTitle="Your AI Assistant"
            description="An all-in-one platform for hosting and delivering cybersecurity simulations, from CTFs to full-scale cyber ranges and cyber drills."
            subDescription="No credit card required"
            image="/images/hero/homepage-hero.png"
            buttons={[
              {
                text: 'Get Started for Free',
                link: 'https://app.simulationslabs.com/register/tenant',
                variant: 'default',
              },
              {
                text: 'Request a Demo',
                link: 'mailto:info@simulationslabs.com',
                variant: 'outline',
              },
            ]}
          />
          <TrustedOrganizations
            title="Trusted By Leading Organizations"
            organizations={[
              '/images/trusted-organizations/1.png',
              '/images/trusted-organizations/2.png',
              '/images/trusted-organizations/3.png',
              '/images/trusted-organizations/4.png',
              '/images/trusted-organizations/5.png',
            ]}
          />
          <CTFCompetition />
          <SupportSection />
          <TestmonialSection />
          <ExploreResourcesSection />
        </div>
      </Layout>
      <div className="bg-darkBlue text-white">
        <div className="container mx-auto flex-1 px-10 pt-6">
          <HeroSection
            title="Unlock the power of Simulations Labs for an enhanced cybersecurity experience."
            image="/images/footer-hero-img.png"
            buttons={[
              {
                text: 'Get Started for Free',
                link: 'https://app.simulationslabs.com/register/tenant',
                variant: 'default',
              },
              {
                text: 'Request a Demo',
                link: 'mailto:info@simulationslabs.com',
                variant: 'outline',
              },
            ]}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
